'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getPageValidationInfo;
/**
 * Returns errors and/or warnings for pages, in general for Common page.
 * @param {string} pageCode - Code (slug) of the page.
 * @param {Object} validationInfo - Data object (parsed JSON) represents the validation data.
 * @return {{error: {title: string, message:Array<string>}, warning: {title: string, message:Array<string>}}} Error and Warning in form of objects consist title and message which is a bullet list as array.
 */
function getPageValidationInfo(pageCode, validationInfo) {
    var error = { title: '', message: [] };
    var warning = { title: '', message: [] };

    if (validationInfo && pageCode) {
        var page = validationInfo.pages.find(function (page) {
            return page.code === pageCode;
        });
        if (page) {
            if (page.errors.length) {
                error.title = page.errorTitle;
                error.message = page.errors.map(function (err) {
                    return { code: err.code, value: err.message };
                });
            }
            if (page.warnings.length) {
                warning.title = page.warningTitle;
                warning.message = page.errors.map(function (war) {
                    return { code: war.code, value: war.message };
                });
            }
        }
    }

    return { error: error, warning: warning };
}